import axios from 'axios';

import { BASE_URL_V3 } from '@/constants/urls';
import Config from '@/config';
import TokenManager from '@/util/tokenManager';

const tokenManager = TokenManager.getInstance();

const axiosClient = axios.create({
  baseURL: BASE_URL_V3,
});

const axiosRubyClient = axios.create({
  baseURL: Config.BASE_RUBY_URL || 'https://api.v2.gravywork.com',
});

axiosClient.interceptors.request.use(async (config) => {
  const token = tokenManager.getAccessToken();

  if (token && config.headers) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

axiosRubyClient.interceptors.request.use(async (config) => {
  const token = tokenManager.getAccessToken();

  if (token && config.headers) {
    config.headers.Authorization = `bearer ${token}`;
  }

  if (
    config.method &&
    ['patch', 'post', 'put'].includes(config.method.toLowerCase())
  ) {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async function (error) {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      const newToken = await tokenManager.ensureFreshToken();
      if (newToken) {
        originalRequest.headers.Authorization = `bearer ${newToken}`;
        return axiosClient(originalRequest);
      }
      tokenManager.logout();
    }
    return Promise.reject(error);
  },
);

axiosRubyClient.interceptors.response.use(
  (response) => response,
  async function (error) {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      const newToken = await tokenManager.ensureFreshToken();
      if (newToken) {
        originalRequest.headers.Authorization = `bearer ${newToken}`;
        return axiosRubyClient(originalRequest);
      }
      tokenManager.logout();
    }
    return Promise.reject(error);
  },
);

export { axiosRubyClient };
export default axiosClient;
